exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.backarrowDiv[data-v-486302e7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-lesson[data-v-486302e7] {\n  margin: auto;\n}\n.noShow[data-v-486302e7] {\n  opacity: 0;\n}\n", "", {"version":3,"sources":["/__w/lang_app_eng/lang_app_eng/src/components/Lesson/lesson-header.vue"],"names":[],"mappings":";AACA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,aAAa;CACd;AACD;EACE,aAAa;CACd;AACD;EACE,WAAW;CACZ","file":"lesson-header.vue","sourcesContent":["\n.backarrowDiv[data-v-486302e7] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  width: 50px;\n  height: 50px;\n}\n.arrow-svg-lesson[data-v-486302e7] {\n  margin: auto;\n}\n.noShow[data-v-486302e7] {\n  opacity: 0;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-486302e7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Lesson/lesson-header.vue
// module id = 287
// module chunks = 0 1 7 8